// removed by extract-text-webpack-plugin
module.exports = {"avatar":"theme__avatar___3OjJz","image":"theme__image___2Ueo9","letter":"theme__letter___26GdB"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/avatar/theme.css
// module id = 1432
// module chunks = 0